export default "__VITE_ASSET__14c444a6__"